import { inject, Injectable } from '@angular/core';

import { BUTTON_COLOR_ACCESSIBILITY, BUTTON_DISPLAY_CONFIG } from './tokens';

@Injectable()
export class ButtonInjectionTokenService {
  protected readonly theme = inject(BUTTON_DISPLAY_CONFIG, { optional: true });
  private readonly colorAccessibility = inject(BUTTON_COLOR_ACCESSIBILITY, {
    optional: true,
  });

  get injectedTheme() {
    return this.theme;
  }

  get injectedColorAccessibility() {
    return this.colorAccessibility;
  }
}
